<script setup lang="ts">
import { ref } from 'vue';
import PackRefundComponent from "./PackRefundComponent.vue";
import config from "../../config.js";

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    item:{
      type:Object,
      required:true,
    },
    fields:{
      type:Array,
      required:true,
    },
})
const refundPackDialog = ref(null);
const refundPackDialogIdentityId = ref(0);
const clickRefundPackButton = (pharmacyPackId) => {
  refundPackDialog.value.showRefundPackEditDialog(pharmacyPackId);
}
</script>

<style scoped>
</style>
<template>
<td v-for="(field,index) in fields" :key="index" :style="'width:' + field.width" class="text-center">
  <div v-if="field.field_key == 'product_name'" class="text-left">
    {{ item.product_name + ' ' + item.package_label }}
  </div>
  <div v-else-if="field.field_key == 'stock_type'">
    <span v-show="item.stock_type == config.STOCK_TYPES['処方']" class="label-prescript">処方</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['VAN']" class="label-van">卸</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['VAN'] && item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['返品']" class="text-xs m-0.5 rounded-full text-red-700 border border-red-700">返品</span>
    <span v-show="item.pharmacy_van != null && item.pharmacy_van.receive_response_code != null && item.delivery_confirm_date == null" class="inline-block text-xs m-0.5 rounded-full text-blue-700 border border-blue-700">配送待ち</span>
    <span v-show="item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['発注無し納品']" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">電話発注</span>
    <span v-show="item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['新薬納品']" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">新薬納品</span>
    <span v-show="item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['分割納品']" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">分割納品</span>
    <span v-show="item.is_wait" class="inline-block text-xs m-0.5 rounded-full text-orange-500 border border-orange-500">納品不足待ち</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['小分け']" class="label-pack">小分け</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['小分け'] && item.number > 0" class="label-pack-buy mt-1">購入</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['小分け'] && item.number < 0" class="label-pack-buy mt-1">販売</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['小分け'] && item.pharmacy_pack != null && item.pharmacy_pack.permit_date" class="text-xs m-0.5 rounded-full text-red-700 border border-red-700">承認</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['小分け'] && item.pharmacy_pack != null && item.pharmacy_pack.delivery_date" class="text-xs m-0.5 rounded-full text-blue-700 border border-blue-700">発送</span>
    <span v-show="item.stock_type == config.STOCK_TYPES['棚卸']" class="label-stock">棚卸</span>
  </div>
  <div v-else-if="field.field_key == 'warning_mark'" :class="field.align">
    <span v-html="item.warning_mark"></span>
  </div>
  <div v-else-if="field.field_key == 'action_content'">
    <div v-show="item.stock_type == config.STOCK_TYPES['処方']">
      {{ item.patient_profile != null ? item.patient_profile.patient_kanji_name + '(' + item.patient_profile.age + ')' + ' ' + item.patient_profile.gender : '' }}
    </div>
    <div v-show="item.stock_type == config.STOCK_TYPES['小分け'] && item.pharmacy_pack != null && item.pharmacy_pack.delivery_date">
      <div class="m-1" v-show="(item.pharmacy_pack != null ? item.pharmacy_pack.permit_date : false)">
        <a :href="'/pdf/assignment/?id=' + (item.pharmacy_pack != null ? item.pharmacy_pack.id : 0)" target="_blank" class="mb-1 block py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-red-400 rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">譲受譲渡書</a>
        <a href="javascript:void(0)" class="block py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-blue-400 rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700" @click="clickRefundPackButton(item.pharmacy_pack.id)">小分け金額調整</a>
      </div>
      <div>{{ (item.lot_no ? 'ロット番号:' + item.lot_no : '') }}</div>
      <div>{{ (item.expire_date ? '有効期限:' + item.expire_date : '') }}</div>
    </div>
    <div v-show="item.stock_type == config.STOCK_TYPES['棚卸']">
      {{ item.stock_reason }} {{ (item.stock_reason ? (item.lot_no ? '\nロット番号：' + item.lot_no : '') + (item.expire_date != null ? ' \n有効期限:' + item.expire_date : '') : '') }}
    </div>
    <div v-show="item.stock_type == config.STOCK_TYPES['VAN']">
      <div class="m-1 text-left" v-show="(item.pharmacy_van != null)" v-html="((item.pharmacy_van != null) ? (item.pharmacy_van != null ? '伝票番号:' + (item.pharmacy_van.slip_number ? item.pharmacy_van.slip_number : 'データ受信待ち') + '<br>' : '') + (item.pharmacy_van != null  && item.pharmacy_van.slip_date ? '伝票日付:' + item.pharmacy_van.slip_date + '<br>' : '') + (item.lot_no ? 'ロット番号:' + item.lot_no : '') + (item.expire_date ? '<br>有効期限:' + item.expire_date : '') + (item.lot_number_order ? '<br>発注時数量:' + item.lot_number_order + '(' + item.number_order + item.medicine.package_unit + ')' : '') + (item.order_date ? '<br>発注日時:' + item.order_date : '') : '')"></div>
    </div>
  </div>
  <div v-else-if="field.field_key == 'number'">
    <div v-if="item.stock_type != config.STOCK_TYPES['棚卸'] || item.stock_reason">{{ item.number.toLocaleString() + item.medicine.package_unit }}</div>
    <div v-else>
      {{ (item.inventory_number != null ? item.inventory_number.toLocaleString() + item.medicine.package_unit : '--') }}
      ({{ item.number.toLocaleString() + item.medicine.package_unit }})
      <div v-show="item.stock_control_reason">{{ item.stock_control_reason }}</div>
    </div>
  </div>
  <div v-else-if="field.field_key == 'unit_price'">
    \{{ item.unit_price.toLocaleString() }}
  </div>
  <div v-else-if="field.field_key == 'total_price'">
    \{{ item.total_price.toLocaleString() }}
  </div>
  <div v-else-if="field.field_key == 'action_history_content'">
    <div v-if="item.stock_type == config.STOCK_TYPES['処方']">
      {{ item.dosage_frequency_label }}
    </div>
    <div v-else-if="item.stock_type == config.STOCK_TYPES['VAN'] || item.stock_type == config.STOCK_TYPES['小分け']">
      {{ item.delivery_confirm_date ? '納品確定日時\n' + item.delivery_confirm_date : '' }}
    </div>
    <div v-else-if="item.stock_type == config.STOCK_TYPES['棚卸']">
      {{ item.created_at ? '棚卸実時間\n' + item.created_at : '' }}
    </div>
  </div>
  <div v-else :class="field.align">
    {{ item[field.field_key] }}
  </div>
</td>
<pack-refund-component
  ref="refundPackDialog"
  :apis="apis"
  :identity-id="refundPackDialogIdentityId"
></pack-refund-component>
</template>

